import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import SideBar from '../organisms/SideBar/SideBar';
import TopBar from '../organisms/TopBar';
import { Helmet } from 'react-helmet';
import { getAppName } from '../../services/appTheme';
import Error from '../molecules/Error';
import { ErrorBoundary } from '../../services/bugsnag';
const Page = styled.div `
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;
const Wrapper = styled.div `
    transition: padding-left 0.2s ease-in-out;
    width: 100%;
    padding: 30px 15px;

    @media only screen and (min-width: 1400px) {
        padding: 30px 30px 30px 310px;
    }
`;
const InnerWrapper = styled.div `
    display: flex;
    max-width: 1600px;
`;
const Layout = ({ children, dossierNumber, ...props }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    return (_jsxs(Page, { ...props, children: [_jsx(Helmet, { titleTemplate: '%s - ' + getAppName() }), _jsx(TopBar, { onClick: () => {
                    setMenuOpen(prevToggle => !prevToggle);
                }, toggleIcon: menuOpen }), _jsxs(InnerWrapper, { children: [_jsx(SideBar, { isVisible: menuOpen, onClose: () => setMenuOpen(false), dossierNumber: dossierNumber }), _jsx(Wrapper, { children: _jsx(ErrorBoundary, { FallbackComponent: Error, children: children }) })] })] }));
};
export default Layout;
